'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function unzip(zipped) {
    var maxLen = 0;
    for(var i = 0; i < zipped.length; i++){
        if (zipped[i].length > maxLen) {
            maxLen = zipped[i].length;
        }
    }
    var result = new Array(maxLen);
    for(var i1 = 0; i1 < maxLen; i1++){
        result[i1] = new Array(zipped.length);
        for(var j = 0; j < zipped.length; j++){
            result[i1][j] = zipped[j][i1];
        }
    }
    return result;
}
exports.unzip = unzip;
